import { render, staticRenderFns } from "./SurgeryInsuranceInvoice.vue?vue&type=template&id=b8c294ce&scoped=true"
import script from "./SurgeryInsuranceInvoice.vue?vue&type=script&lang=js"
export * from "./SurgeryInsuranceInvoice.vue?vue&type=script&lang=js"
import style0 from "./SurgeryInsuranceInvoice.vue?vue&type=style&index=0&id=b8c294ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8c294ce",
  null
  
)

export default component.exports